<template>
  <div class="icon-wrapper" :class="colorClass">
    <svg class="icon" :width="width" :height="height">
      <use v-bind="{ 'xlink:href': '/feather-sprite.svg#' + name }"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Icon",
  props: {
    name: String,
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    colorClass: {
      type: String
    }
  }
};
</script>

<style scoped>
.icon-wrapper {
  color: whitesmoke;
  font-size: 1rem;
  font-weight: 600;
}
.icon {
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  margin-right: 6px;
}
.colorBlack {
  color: black;
}
</style>
